import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { FormattedDate } from 'components/intl'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { FormData, Status, Button } from 'components/misc'
import { form } from '../../../helpers/decorators'
import { injectIntl } from 'react-intl'
import { getActivityName, getCategoryName, getSection } from '../../../helpers/assessorHelper'


@form({
  form: 'assessor-file-detail-modal',
  disableHook: true
})
@injectIntl
class AssessorFileDetailModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    assessor: PropTypes.object
  }

  static defaultProps = {
    data: {}
  }

  getAssessorName = data => {
    const { assessor } = this.props

    if (get(data, 'author.firstName')) {
      return (get(data, 'author.firstName') + " " + get(data, 'author.lastName'))
    }

    return (get(assessor, 'firstName') + " " + get(assessor, 'lastName'))
  }

  render() {
    const { modalId, data } = this.props

    return (
      <Modal id={modalId} customActions>
        <Title h2 intlKey="moduleTitle.assessor_details">
          Assessor details
        </Title>
        <div className="row">
          <div className="col-xs-12">
            <FormData label="Title" intlKey="label.title">
              {get(data, 'title') || '---'}
            </FormData>
          </div>
          <div className="col-xs-12">
            <FormData label="Description" intlKey="label.description">
              {get(data, 'description') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Author" intlKey="label.author">
              {this.getAssessorName(data)}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Created at" intlKey="label.created_at">
              {get(data, 'createdAt') && (
                  <FormattedDate value={get(data, 'createdAt')} />
              )}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Activity" intlKey="label.activity">
              {getSection(data)}<br />
              {getActivityName(data)}<br />
              {getCategoryName(data)}<br />
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="WWC" intlKey="label.wwc">
              <Status
                  state={get(data, 'isWWC')}
                  check
                  noWaiting
                  inline
              />
            </FormData>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text--right">
            <Button
                intlKey="button.close"
                secondary
                type="button"
                onClick={() => this.props.modal(null)}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default AssessorFileDetailModal
